import Vue from 'vue'
import axios from 'axios'
import { deviceRef, userSessionRef, streamingVideosRef, activeExamRef, activeUsersRef } from '../../../firebase'
Vue.use(axios)
export default {
  getUserAndLecture (data) {
    return new Promise((resolve, reject) => {
      axios.get('getUserAndLecture/' + data.user_id + '/' + data.lecture_id)
        .then(response => {
          resolve(response.data)
        })
    })
  },
  uploadInstituteAssistance  ({state}, data) {
    return new Promise ((resolve, reject) => {
      axios.post('uploadInstituteAssistance', data)
        .then(response => {
          resolve(response.data)
      })
    })
  },
  getUserNameByIdArray ({state}, arr) {
    return new Promise ((resolve, reject) => {
      axios.post('getUserNameByIdArray', arr)
        .then(response => {
          state.usersList = response.data
          resolve(response.data)
      })
    })
  },
  getUserName ({state}, userId) {
    return new Promise((resolve, reject) => {
      axios.get('getUserName/' + userId)
        .then(response => {
          resolve(response.data)
        })
    })
  },
  getLecturesNumberForLMS ({ state }) {
    let courseList = []
    let lectureCountList = []
    axios.get('getLecturesNumberForLMS')
      .then(response => {
        let data = response.data
        // state.lectureCountList = response.data
        data.forEach((item) => {
          courseList.push(item.name)
          lectureCountList.push(item.total)
        })

        let options = {
          chart: {
            id: 'bar-chart'
          },
          plotOptions: {
            bar: {
              distributed: false
            }
          },
          theme: {
            palette: 'palette9'
          },
          xaxis: {
            categories: courseList
          },
          title: {
            text: 'Lecture Count Of Courses'
          }
        }
        let series = [
          {
            name: 'Lecture Count',
            data: lectureCountList
          }
        ]
        state.lectureOption = options
        state.lectureSeries = series
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getTodayVideos ({ state }) {
    let pieSeries = []
    let labels = []
    axios.get('getTodayVideos')
      .then(response => {
        let data = response.data
        console.log(data)
        data.forEach((item) => {
          labels.push(item.lecture.title)
          pieSeries.push(item.total)
        })

        let series = [
          {
            name: 'Today\'s Mostly Watched Lectures',
            data: pieSeries
          }
        ]
        state.topVideoSeries = series
        state.topVideoChartOptions = {
          labels: labels,
          theme: {
            palette: 'palette4'
          },
          chart: {
            height: 'auto'
          },
          title: {
            text: 'Today\'s Most Watched Lectures'
          },
          plotOptions: {
            bar: {
              barHeight: '90%',
              distributed: false,
              horizontal: true
            }
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },

  getUserNumberByCountry ({ state }) {
    let pieSeries = []
    let labels = []
    axios.get('getUserNumberByCountry')
      .then(response => {
        let data = response.data
        data.forEach((item) => {
          labels.push(item.isBangladeshi ? 'Bangladeshi' : 'Foreigner')
          pieSeries.push(item.total)
        })

        // let series = [
        //   {
        //     name: 'User\'s Country',
        //     data: pieSeries
        //   }
        // ]
        state.countrySeries = pieSeries
        state.countryChartOptions = {
          labels: labels,
          theme: {
            monochrome: {
              enabled: true
            }
          },
          title: {
            text: 'User\'s Country'
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },

  getUserNumberByCourse ({ state }) {
    let courseList = []
    let userCountList = []
    axios.get('getUserNumberByCourse')
      .then(response => {
        let data = response.data
        // state.userCountList = response.data
        data.forEach((item) => {
          courseList.push(item.name)
          userCountList.push(item.total)
        })

        let options = {
          chart: {
            id: 'bar-chart'
          },
          xaxis: {
            categories: courseList
          },
          title: {
            text: 'Current Course Enrollment Count'
          }
        }
        let series = [
          {
            name: 'Enrollment Count',
            data: userCountList
          }
        ]
        state.userCourseChartOptions = options
        state.userCourseSeries = series
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getUserNumberByGender ({ state }) {
    let pieSeries = []
    let labels = []
    axios.get('getUserNumberByGender')
      .then(response => {
        let data = response.data
        data.forEach((item) => {
          labels.push(item.gender !== null ? item.gender : 'Not updated')
          pieSeries.push(item.total)
        })

        state.genderSeries = pieSeries
        state.genderChartOptions = {
          labels: labels,
          theme: {
            palette: 'palette2'
          },
          title: {
            text: 'Gender'
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
      }).catch((err) => {
      })
  },
  getChapterNumberByCourse ({ state }) {
    let courseList = []
    let subjectCountList = []
    axios.get('getChapterNumberByCourse')
      .then(response => {
        let data = response.data
        // state.subjectCountList = response.data
        data.forEach((item) => {
          courseList.push(item.name)
          subjectCountList.push(item.total)
        })

        let options = {
          chart: {
            id: 'bar-chart'
          },
          theme: {
            palette: 'palette6'
          },
          plotOptions: {
            bar: {
              distributed: false
            }
          },
          xaxis: {
            categories: courseList
          },
          title: {
            text: 'Chapter Count Of Courses'
          }
        }
        let series = [
          {
            name: 'Chapter Count',
            data: subjectCountList
          }
        ]
        state.chapterOption = options
        state.chapterSeries = series
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getLecturesSumForLMS ({ state }) {
    let list = []
    let lectureDurationSumList = []
    axios.get('getLecturesSumForLMS')
      .then(response => {
        let data = response.data
        // state.lectureDurationSumList = response.data
        data.forEach((item) => {
          list.push(item.name)
          lectureDurationSumList.push(Math.floor((parseInt(item.total) / 60) / 60))
        })

        let options = {
          chart: {
            id: 'bar-chart'
          },
          xaxis: {
            categories: list
          },
          theme: {
            palette: 'palette2'
          },
          plotOptions: {
            bar: {
              distributed: false
            }
          },
          title: {
            text: 'Course duration (Hours)'
          }
        }
        let series = [
          {
            name: 'Lecture Duration Graph',
            data: lectureDurationSumList
          }
        ]
        state.courseDurationOptions = options
        state.courseDurationSeries = series
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getSubjectNumberByCourse ({ state }) {
    let courseList = []
    let subjectCountList = []
    axios.get('getSubjectNumberByCourse')
      .then(response => {
        let data = response.data
        // state.subjectCountList = response.data
        data.forEach((item) => {
          courseList.push(item.name)
          subjectCountList.push(item.total)
        })

        let options = {
          chart: {
            id: 'bar-chart'
          },
          xaxis: {
            categories: courseList
          },
          title: {
            text: 'Subject Count Of Courses'
          },
          plotOptions: {
            bar: {
              distributed: false,
              barHeight: '50px'
            }
          },
          theme: {
            palette: 'palette1'
          }

        }
        let series = [
          {
            name: 'Subject Count',
            data: subjectCountList
          }
        ]
        state.subjectOption = options
        state.subjectSeries = series
      }).catch((err) => {
      })
  },

  getLecturesNumberByFree ({ state }) {
    let pieSeries = []
    let labels = []
    axios.get('getLecturesNumberByFree')
      .then(response => {
        let data = response.data
        // state.subjectCountList = response.data
        data.forEach((item) => {
          labels.push(item.isFree ? 'Free' : 'Premium')
          pieSeries.push(item.total)
        })

        state.isFreeSeries = pieSeries
        state.isFreeOptions = {
          labels: labels,
          theme: {
            monochrome: {
              enabled: true
            }
          },
          title: {
            text: 'Free VS Premium Lectures'
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },

  getFirebaseDataFromStore ({ commit, state }) {
    let devices = []
    let users = []
    let streamingVideos = []
    deviceRef.on('child_added', snapshot => {
      let val = snapshot.val()
      devices.push({ ...val })
    })
    userSessionRef.on('child_added', snapshot => {
      let val = snapshot.val()
      users.push({ ...val })
    })
    streamingVideosRef.on('child_added', snapshot => {
      let val = snapshot.val()
      let videoInfo = val[Object.keys(val)[0]]
      if (videoInfo.playing) {
        streamingVideos.push(videoInfo)
      }
      state.liveStreamingNumber = streamingVideos.length
    })
    streamingVideosRef.on('child_removed', snapshot => {
      let val = snapshot.val()
      let videoInfo = val[Object.keys(val)[0]]
      streamingVideos.splice(streamingVideos.indexOf(videoInfo), 1)
      state.liveStreamingNumber = streamingVideos.length
    })
    streamingVideosRef.on('child_changed', snapshot => {
      let val = snapshot.val()
      let videoInfo = val[Object.keys(val)[0]]
      let isPlaying = videoInfo.playing
      if (!isPlaying) {
        videoInfo.playing = false
        console.log(streamingVideos[streamingVideos.indexOf(videoInfo)])
        // console.log(streamingVideos[streamingVideos.indexOf(videoInfo)])
        streamingVideos.splice(streamingVideos.indexOf(videoInfo), 1)
      } else {
        var count = 0
        streamingVideos.forEach(element => {
          if (element.device_id === videoInfo.device_id && element.lecture_id === videoInfo.lecture_id) {

          } else {
            count++
          }
        })
        if (count === streamingVideos.length) {
          streamingVideos.push(videoInfo)
        }
      }
      state.liveStreamingNumber = streamingVideos.length
    })
    let currentExamList = []
    activeExamRef.on('child_added', snapshot => {
      let val = snapshot.val()
      currentExamList.push({ ...val })
      state.currentlyExamParticipant = currentExamList.length
    })
    activeExamRef.on('child_removed', snapshot => {
      // let val = snapshot.val()
      currentExamList.splice(0, 1)
      state.currentlyExamParticipant = currentExamList.length
    })

    let activeUserList = []
    activeUsersRef.on('child_added', snapshot => {
      let val = snapshot.val()
      activeUserList.push({ ...val })
      state.activeUserNumber = activeUserList.length
    })
    activeUsersRef.on('child_removed', snapshot => {
      // let val = snapshot.val()
      activeUserList.splice(0, 1)
      state.activeUserNumber = activeUserList.length
    })

  },
  setLiveStreamingNumber ({ state }, val) {
    state.liveStreamingNumber = val
  }
}
